// extracted by mini-css-extract-plugin
export default {"self":"SecondaryButton_self__jFA8Z"};